import React from "react";
import DataTable from "../../../components/DataTable";
const dataJson = [
  {
    id: "4347348",
    sn: "01",
    date: "01/03/2022",
    amount: "$1548",
    remarks: "58",
    txnNumber: "4s8fd5s8rsf",
  },
  {
    id: "fdf7sf8",
    sn: "02",
    date: "09/03/2022",
    amount: "$7854",
    remarks: "78",
    txnNumber: "dfsf7sf8",
  },
  {
    id: "df7s8f8s",
    sn: "03",
    date: "01/04/2022",
    amount: "$789",
    remarks: "78",
    txnNumber: "sfsrBrtg7",
  },
  {
    id: "sfe7rf",
    sn: "04",
    date: "13/03/2022",
    amount: "$785",
    remarks: "69",
    txnNumber: "dfd4fsf",
  },
];

const columns = [
  { id: "sn", label: "S.N", minWidth: 20 },
  { id: "date", label: "Date", minWidth: 100 },
  {
    id: "amount",
    label: "Amount",
    minWidth: 80,
  },
  {
    id: "remarks",
    label: "Remarks",
    minWidth: 80,
  },
  {
    id: "txnNumber",
    label: "Txn Number",
    minWidth: 100,
  },
];

function createData(sn, date, amount, remarks, txnNumber) {
  return {
    sn,
    date,
    amount,
    remarks,
    txnNumber,
  };
}

const rows = dataJson.map((d) =>
  createData(d.sn, d.date, d.amount, d.remarks, d.txnNumber)
);

const DirectBonusTable = () => {
  return (
    <DataTable
      columns={columns}
      rows={rows}
      perPageShow={6}
      tableHeight={440}
      className="common_table"
    />
  );
};

export default DirectBonusTable;
